export default function setDocument(data, merge = true) {
	return data.ref.set(data, { merge });
}
